import React, { useState, useEffect } from "react";
import "../pages/styles.css";
import Header from "../components/header";
import { LazyLoadImage } from "react-lazy-load-image-component";
import axios from "axios";
import Footer from "../components/Footer";
import { useSelector, useDispatch } from "react-redux";
import { loginModal, loginUser } from "../Redux/authAction";
import { useNavigate } from "react-router-dom";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Typography from "@mui/material/Typography";
import apiConfig from '../config/api.js';  // Import API config

const Catelog = () => {
  const [data, setData] = useState([]);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  // Moved all useSelector hooks to the top level
  const isLang = useSelector((state) => state.authReducer.lang);
  const isAuthenticated = useSelector((state) => state.authReducer.isAuthenticated);
  const displayName = useSelector((state) => state.authReducer.displayName);
  const email = useSelector((state) => state.authReducer.email);
  const packageid = useSelector((state) => state.authReducer.packageid);
  const uid = useSelector((state) => state.authReducer.uid);
  const status = useSelector((state) => state.authReducer.status);

  const [openModel, setOpenModel] = useState(false);
  const [menu, setMenu] = useState("");

  const handleMouseOver = (type) => {
    setMenu(type);
  };

  const handleOpen = () => {
    dispatch(loginModal(true));
  };

  const handleCloseModel = () => {
    setOpenModel(false);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          `${apiConfig.API_URL}/aapi/tempbycat.php?title=Resume maker`
        );
        setData(response.data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  const handleTemplateSelect = (item) => {
    console.log("function is called....");

    const temp_pkgid = item.pkgid;
    const temp_id = item.id;
    console.log("Display Name",displayName,"User Id", uid,"User Package id", packageid,"Status", status,"Template package id", temp_pkgid, "templateid:", temp_id);

    if (uid !== null) {
      dispatch(
        loginUser({
          displayName,
          uid,
          email,
          packageid,
          status,
          temp_pkgid,
          temp_id,
        })
      );
    }

    navigate(`/pages/specificbuilder/${item.templetepath}`);
  };

  return (
    <>
      <Header menu={menu} setMenu={setMenu} />
      <div onMouseOver={() => handleMouseOver("")} className="text-black"></div>
      <div className="pt-20 bg-purple-500">
      <div className={`grid grid-cols-2 p-5 ${isLang === "eng" ? "" : "rtl"}`}>
  {isLang === "eng" ? (
    <>
      {/* English layout */}
      <div className="p-10 ml-5 text-white text-[16px] font-[100px]">
        <p className="text-4xl font-semibold">
          Resume Builder
        </p>
        <br />
        <p style={{ fontSize: "16px" }}>
          Elevate your job application with Maker4U's intuitive resume builder, enabling you to create an outstanding resume in minutes. Explore a diverse collection of meticulously designed templates, complemented by official fonts and other design elements, all tailored to help you showcase your skills effectively.
        </p>
        <br />
        <p style={{ fontSize: "16px" }}>
          With Maker4U's user-friendly platform, you don't need design skills. Simply unleash your creativity and craft a resume that grabs the attention of HR departments from the get-go. Stand out from the competition and increase your chances of landing interviews with ease.
        </p>
        <br />
        <p style={{ fontSize: "16px" }}>
          Don't miss out on the opportunity to impress potential employers. Start building your remarkable resume with Maker4U today and take the first step towards advancing your career.
        </p>
      </div>

      <div>
        <LazyLoadImage
          src="/assets/image2.png"
          alt="Image"
          className="w-full h-full px-4"
        />
      </div>
    </>
  ) : (
    <>
      {/* Arabic layout */}
      <div>
        <LazyLoadImage
          src="/assets/image2.png"
          alt="Image"
          className="w-full h-full px-4"
        />
      </div>

      <div className="p-10 ml-5 text-white text-[16px] font-[100px] text-right">
        <p className="text-4xl font-semibold">
          منشئ السيرة الذاتية
        </p>
        <br />
        <p style={{ fontSize: "16px" }}>
          أرتقي بطلب الوظيفة الخاص بك باستخدام أداتنا السلسة لإنشاء السيرة الذاتية من Maker4U، والتي تمكنك من إنشاء سيرة ذاتية رائعة في دقائق. استكشف مجموعة متنوعة من النماذج المصممة بعناية، والمكملة بخطوط رسمية وعناصر تصميم أخرى مصممة لمساعدتك على عرض مهاراتك بشكل فعال.
        </p>
        <br />
        <p style={{ fontSize: "16px" }}>
          مع منصة Maker4U سهلة الاستخدام، لست بحاجة إلى مهارات التصميم. ما عليك سوى إطلاق العنان لإبداعك وصياغة سيرة ذاتية تجذب انتباه أقسام الموارد البشرية من اول نظرة. تميز عن المنافسة وزد من فرصك في الحصول على مقابلات بسهولة.
        </p>
        <br />
        <p style={{ fontSize: "16px" }}>
          لا تفوت الفرصة لإبهار أصحاب العمل المحتملين. ابدأ في بناء سيرتك الذاتية الرائعة مع Maker4U اليوم واتخذ الخطوة الأولى نحو تطوير حياتك المهنية.
        </p>
      </div>
    </>
  )}
</div>

      </div>
      <p className="text-[2em] text-center font-[500] mt-10">
  {isLang === "eng"
    ? "Get inspired by expertly crafted resume examples"
    : "احصل على الإلهام من أمثلة السيرة الذاتية المصممة بخبرة"}
</p>

<div className="flex justify-center" style={{ marginTop: "20px", marginBottom: "20px" }}>
  <div className="text-center" style={{ maxWidth: "1200px" }}>
    <p
      style={{
        fontFamily: "poppins",
        fontSize: "16px",
        fontWeight: "400",
        lineHeight: "1.375rem",
        letterSpacing: ".024375rem",
      }}
    >
      {isLang === "eng"
        ? `Start your resume design journey with confidence, thanks to Maker4U's comprehensive selection of professional resume templates. Unsure of where to begin? Fear not! Our user-friendly platform offers an abundance of well-designed templates and resume examples to spark your inspiration.
        With Maker4U's online resume builder at your disposal, crafting your dream resume is as easy as waving a magic wand. Simply select a premade professional template that resonates with your style, upload your image, and utilize our intuitive editing tools to customize every aspect of your resume.
        In just a few clicks, you'll have a perfectly tailored resume that showcases your skills and experiences in the best possible light—all created online and completely free of charge.
        Don't let uncertainty hold you back. Start your resume design journey today with Maker4U and unlock endless possibilities for career success.`
        : `ابدأ رحلة تصميم سيرتك الذاتية بثقة، وذلك بفضل مكتبة Maker4U الشاملة من نماذج السيرة الذاتية الاحترافية. هل أنت غير متأكد من أين تبدأ؟ لا تخف! توفر منصتنا سهلة الاستخدام وفرة من النماذج المصممة بعناء وأمثلة السيرة الذاتية لإثارة إلهامك.
        مع أداة إنشاء السيرة الذاتية عبر الإنترنت من Maker4U تحت يدك، فإن صياغة سيرتك الذاتية التي تحلم بها أمر سهل مثل التلويح بعصا سحرية. ما عليك سوى تحديد نموذج احترافي جاهز يتوافق مع أسلوبك، وتحميل صورتك، والاستفادة من أدوات التحرير البديهية لدينا لتخصيص كل جانب من جوانب سيرتك الذاتية.
        في بضع نقرات فقط، ستحصل على سيرة ذاتية مصممة بشكل مثالي تعرض مهاراتك وخبراتك بأفضل صورة ممكنة - كل ذلك تم إنشاؤه عبر الإنترنت ومجاني تمامًا.
        لا تدع الشك يعيقك. ابدأ رحلة تصميم سيرتك الذاتية اليوم مع Maker4U وافتح إمكانيات لا حصر لها للنجاح الوظيفي.`}
    </p>
  </div>
      </div>
      <div
  className="card-container"
  style={{
    display: "grid",
    gridTemplateColumns: "repeat(5, 1fr)", // 5 items per row
    gap: "20px", // Add spacing between items
    justifyContent: "center", // Optional: centers the entire grid
  }}
>
  {data.map((item) => (
    <Card
      key={item.id}
      sx={{ maxWidth: 225 }}
      className="cursor-pointer"
      onClick={() => handleTemplateSelect(item)}
    >
      <CardMedia
        component="img"
        alt={item.title}
        className="h-[300px]"
        image={`${apiConfig.API_URL}/aapi/templetes/${item.imagepath}`}
      />
      <CardContent
        className="m-0 h-8 pb-3 text-left font-medium"
        style={{ fontFamily: "poppins" }}
      >
        <Typography gutterBottom variant="h8" component="div">
          {item.title}
        </Typography>
      </CardContent>
    </Card>
  ))}
</div>

      <p className="text-[2em] text-center font-[500] mt-10">
  {isLang === "eng"
    ? "Pick one of many world-class templates and build your resume in minutes"
    : "اختر أحد النماذج العديدة ذات المستوى العالمي وقم ببناء سيرتك الذاتية في دقائق"}
</p>

<div className="flex justify-center" style={{ marginTop: "20px", marginBottom: "20px" }}>
  <div className="text-center" style={{ maxWidth: "1200px" }}>
    <p
      style={{
        fontFamily: "poppins",
        fontSize: "16px",
        fontWeight: "400",
        lineHeight: "1.375rem",
        letterSpacing: ".024375rem",
      }}
    >
      {isLang === "eng"
        ? `Transform your resume into a masterpiece with Maker4U's array of world-class templates, designed to impress at first glance. With our intuitive platform, you can craft a professional resume in minutes, showcasing your skills and experiences with ease.
        Choose from a diverse selection of meticulously crafted templates, each tailored to suit different industries and career paths. Whether you're a seasoned professional or just starting out, there's a template that's perfect for you.
        With Maker4U's user-friendly interface, building your resume is a breeze. Simply pick a template, input your information, and watch as your resume comes to life in minutes.`
        : `حوِّل سيرتك الذاتية إلى تحفة فنية باستخدام مجموعة Maker4U من القوالب ذات المستوى العالمي، والمصممة لإبهارك من النظرة الأولى. باستخدام منصتنا، يمكنك إنشاء سيرة ذاتية احترافية في دقائق، مع عرض مهاراتك وخبراتك بسهولة.
        اختر من بين مجموعة متنوعة من النماذج المصممة بعناية، وكل منها مصمم ليناسب صناعات ومسارات مهنية مختلفة. سواء كنت محترفًا متمرسًا أو مبتدئًا، ستجد نموذج مثالي لك.
        مع واجهة Maker4U سهلة الاستخدام، يصبح إنشاء سيرتك الذاتية أمرًا سهلاً. ما عليك سوى اختيار نموذج وإدخال معلوماتك ومشاهدة سيرتك الذاتية تنبض بالحياة في دقائق.`}
    </p>
  </div>
</div>
<p className="text-[2em] text-center font-[500] mt-10">
  {isLang === "eng" ? "Customize Your Own Resume" : "قم بتخصيص سيرتك الذاتية"}
</p>

<div className="flex justify-center" style={{ marginTop: "20px", marginBottom: "20px" }}>
  <div className="text-center" style={{ maxWidth: "1200px" }}>
    <p
      style={{
        fontFamily: "poppins",
        fontSize: "16px",
        fontWeight: "400",
        lineHeight: "1.375rem",
        letterSpacing: ".024375rem",
      }}
    >
      {isLang === "eng"
        ? `Tailor your resume to perfection with Maker4U's intuitive customization features, empowering you to showcase your unique skills and experiences with flair. Our platform offers a seamless experience, allowing you to create a personalized resume that stands out from the crowd.
        With Maker4U's easy-to-use tools, you can customize every aspect of your resume—from layout and design to fonts and colors. Whether you're aiming for a sleek and modern look or a classic and sophisticated style, the possibilities are endless.
        Explore your creativity and make your resume truly your own. Start crafting your personalized masterpiece with Maker4U today and take the first step towards your dream career.`
        : `قم بتخصيص سيرتك الذاتية لتصل لمرحلة الكمال باستخدام ميزات التخصيص البديهية من Maker4U، والتي تمكنك من عرض مهاراتك وخبراتك الفريدة ببراعة. توفر منصتنا تجربة سلسة، مما يسمح لك بإنشاء سيرة ذاتية مخصصة تبرز من بين الحشود.
        باستخدام أدوات Maker4U السلسة، يمكنك تخصيص كل جانب من جوانب سيرتك الذاتية - من التخطيط والتصميم إلى الخطوط والألوان. سواء كنت تهدف إلى مظهر أنيق وحديث أو أسلوب كلاسيكي ومتطور، فإن الاحتمالات لا حصر لها.
        استكشف إبداعك واجعل سيرتك الذاتية خاصة بك حقًا. ابدأ في صياغة تحفتك الفنية المخصصة مع Maker4U اليوم واتخذ الخطوة الأولى نحو مهنة أحلامك.`}
    </p>
  </div>
</div>
<p className="text-[2em] text-center font-[500] mt-10">
  {isLang === "eng"
    ? "Beautify Your Profile Image Well on Resume"
    : "قم بتجميل صورة ملفك الشخصي في السيرة الذاتية"}
</p>

<div className="flex justify-center" style={{ marginTop: "20px", marginBottom: "20px" }}>
  <div className="text-center" style={{ maxWidth: "1200px" }}>
    <p
      style={{
        fontFamily: "poppins",
        fontSize: "16px",
        fontWeight: "400",
        lineHeight: "1.375rem",
        letterSpacing: ".024375rem",
      }}
    >
      {isLang === "eng"
        ? `Make a lasting impression with Maker4U's innovative feature to enhance your profile image on your resume. Our platform empowers you to beautify your photo, ensuring that your professional appearance shines through.
        With Maker4U's advanced editing tools, you can easily adjust the brightness, contrast, and color balance of your profile image to achieve the perfect look. Whether you're aiming for a polished and professional appearance or a warm and approachable vibe, our customization options have you covered.
        Stand out from the crowd and leave a memorable impression on recruiters with a beautifully enhanced profile image on your resume. Start beautifying your profile image with Maker4U today and take your resume to the next level.`
        : `اترك انطباعًا دائمًا مع ميزة Maker4U المبتكرة لتعزيز صورة ملفك الشخصي في سيرتك الذاتية. تتيح لك منصتنا تجميل صورتك، مما يضمن إبراز مظهرك المهني.
        باستخدام أدوات التحرير المتقدمة من Maker4U، يمكنك بسهولة ضبط سطوع وتباين وتوازن الألوان في صورة ملفك الشخصي لتحقيق المظهر المثالي. سواء كنت تهدف إلى مظهر مصقول واحترافي أو أجواء دافئة وودية، فإن خيارات التخصيص لدينا ستغطي احتياجك.
        اسطع من بين الحشود واترك انطباعًا لا يُنسى لدى مديري التوظيف بصورة ملف تعريف محسّنة بشكل جميل في سيرتك الذاتية. ابدأ في تجميل صورة ملفك الشخصي مع Maker4U اليوم وأرتقي بسيرتك الذاتية إلى المستوى التالي.`}
    </p>
  </div>
</div>
<p className="text-[2em] text-center font-[500] mt-10">
  {isLang === "eng" ? "How to Make a Resume:" : "كيفية إنشاء السيرة الذاتية:"}
</p>

<div className="flex justify-center" style={{ marginTop: "20px", marginBottom: "20px" }}>
  <div className="text-center" style={{ maxWidth: "1400px" }}>
    <p
      className={`${
        isLang === "eng" ? "text-left" : "text-right"
      }`}
      style={{
        fontFamily: "poppins",
        fontSize: "16px",
        fontWeight: "400",
        lineHeight: "1.375rem",
        letterSpacing: ".024375rem",
      }}
    >
      {isLang === "eng" ? (
        <span>
          Crafting a standout resume is essential for job seekers:
          <br />
          - <strong>Choose Format</strong>: Select the appropriate format for your background.
          <br />
          - <strong>Include Contact Info</strong>: Provide clear and professional contact details, including name, phone, email, and LinkedIn profile.
          <br />
          - <strong>Write Objective</strong>: Craft a concise summary or objective statement tailored to your career goals.
          <br />
          - <strong>List Work Experience</strong>: Highlight key responsibilities and achievements in reverse chronological order.
          <br />
          - <strong>Showcase Education</strong>: Include relevant educational background, such as degrees and honors.
          <br />
          - <strong>Highlight Skills</strong>: Feature pertinent technical and soft skills to align with job requirements.
          <br />
          - <strong>Review and Edit</strong>: Ensure clarity, grammar, and consistency through thorough review and editing.
          <br />
          - <strong>Save and Send</strong>: Save your resume as a PDF and follow employer instructions for submission.
          <br />
        </span>
      ) : (
        <span>
          إن إنشاء سيرة ذاتية مميزة أمر ضروري للباحثين عن عمل:
          <br />
           <strong>اختر التنسيق</strong>: حدد التنسيق المناسب لخلفيتك.
          - <br />
          <strong>أدرج معلومات الاتصال</strong>: قم بتقديم تفاصيل اتصال واضحة ومهنية، بما في ذلك الاسم والهاتف والبريد الإلكتروني وملف LinkedIn.
          - <br />
          <strong>اكتب الهدف</strong>: قم بصياغة ملخص موجز أو بيان مصمم خصيصًا لأهدافك المهنية.
          - <br />
          <strong>أدرج الخبرة العملية</strong>: قم بتسليط الضوء على المسؤوليات والإنجازات الرئيسية بترتيب زمني عكسي.
          - <br />
          <strong>أبرز التعليم</strong>: قم بتضمين الخلفية التعليمية ذات الصلة، مثل الدرجات والجوائز.
          - <br />
          <strong>أبرز المهارات</strong>: قم بإبراز المهارات الفنية والشخصية ذات الصلة لتتماشى مع متطلبات الوظيفة.
          - <br />
          <strong>المراجعة والتحرير</strong>: تأكد من الوضوح والقواعد النحوية والاتساق من خلال المراجعة والتحرير الشاملين.
          - <br />
          <strong>احفظ وأرسل</strong>: احفظ سيرتك الذاتية بتنسيق PDF واتبع تعليمات صاحب العمل للتقديم.
          - <br />
        </span>
      )}
    </p>
  </div>
</div>



      <Footer />
    </>
  );
};

export default Catelog;
